import { render, staticRenderFns } from "./GalleriesEditTabContent.vue?vue&type=template&id=c4fdbdf2&"
import script from "./GalleriesEditTabContent.vue?vue&type=script&lang=js&"
export * from "./GalleriesEditTabContent.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesEditTabContent.vue?vue&type=style&index=0&id=c4fdbdf2&prod&lang=css&"
import style1 from "./GalleriesEditTabContent.vue?vue&type=style&index=1&id=c4fdbdf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports